import React from 'react';
import QuoteRequestList from './QuoteRequestList';

/**
 * Thin per-type pages over the generic quote-request list.
 * `types` maps to /admin/enquiry-list?type= (comma-separated allowed).
 * Sell Old Boiler includes the legacy OLD_BOILER subType alongside the
 * current SELL_OLD_EQUIPMENT so older requests stay visible.
 */
export const AmcRequests = () => (
  <QuoteRequestList title="AMC Requests" types="AMC" />
);

export const SellOldBoilerRequests = () => (
  <QuoteRequestList
    title="Sell Old Boiler"
    types="SELL_OLD_EQUIPMENT,OLD_BOILER"
  />
);

export const ExpertAdviceRequests = () => (
  <QuoteRequestList title="Expert Advice" types="EXPERT_ADVICE" />
);

export const SiteVisitRequests = () => (
  <QuoteRequestList title="Site Visit" types="SITE_VISIT" />
);

export { default as QuoteRequestDetail } from './QuoteRequestDetail';
